exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".portlet_content {\n  padding: 2rem;\n}\n\n.portlet_wrapper {\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);\n}\n.portlet_wrapper.portlet__gray {\n  background-color: #eaeaea;\n  border: solid 1px #ffffff;\n  box-shadow: none;\n}\n.portlet_wrapper.portlet__gray .portlet_content {\n  padding: 2rem 0;\n}", ""]);

// exports
